export default "__VITE_ASSET__CNueHojv__"